import { lazy } from "react";
import { ICONS } from "./helpers/Icons/Icons";

const EntryPoint = lazy(() => import("./components/EntryPoint/EntryPoint"));

const IntegrationsFeature = lazy(() =>
  import("./components/Integrations/Integrations")
);

export const defaultPath = `/integrations`;

export const innerRoutes = [
  {
    path: `${defaultPath}`,
    Component: IntegrationsFeature,
    exact: true,
    icon: ICONS.LOGO,
    title: {
      key: "",
      plural: false,
    },
    subTitle: {
      key: "Gestioná tus integraciones",
      plural: false,
    },
  },
];

const IntegrationsBase = {
  path: defaultPath,
  Component: EntryPoint,
  exact: false,
  icon: ICONS.LOGO,
  title: {
    key: "Integraciones",
    plural: false,
  },
  subTitle: {
    key: "Gestioná tus integraciones",
    plural: false,
  },
  innerRoutes: innerRoutes,
  pathChilds: innerRoutes.map((e) => e.path),
};

export default IntegrationsBase;
